// @owners { team: patients }
import { type ErrorObject } from '@alto/core/types/v1/error_object';
import { ADD_TO_UPCOMING_DELIVERY_ERROR_MESSAGE } from '../constants';

// Matching on copy is a stopgap until add_to_shipment sends a machine-readable
// error code. If detection regresses, the toast degrades to the generic message.
const PATIENT_FACING_ADD_TO_SHIPMENT_ERROR = /Update your payment method|out of refills/i;

const isPatientFacingAddToShipmentErrorMessage = (message: string): boolean =>
  PATIENT_FACING_ADD_TO_SHIPMENT_ERROR.test(message);

const isPatientFacingAddToShipmentError = (error: ErrorObject): boolean =>
  isPatientFacingAddToShipmentErrorMessage(`${error.title ?? ''} ${error.detail ?? ''}`);

export const getAddToShipmentPatientErrorMessage = (
  errors?: ErrorObject[] | null,
  fallbackMessage?: string,
): string => {
  const patientFacingError = errors?.find(isPatientFacingAddToShipmentError);
  if (patientFacingError) {
    return patientFacingError.detail || patientFacingError.title || ADD_TO_UPCOMING_DELIVERY_ERROR_MESSAGE;
  }

  if (fallbackMessage && isPatientFacingAddToShipmentErrorMessage(fallbackMessage)) {
    return fallbackMessage;
  }

  return ADD_TO_UPCOMING_DELIVERY_ERROR_MESSAGE;
};
